// src/components/ProfileSyncWatcher.jsx
import { useUserProfile } from '../hooks/useUserProfile';

// Mounted once, globally, in App.jsx. Its only job is to keep
// useUserProfile's query alive app-wide so currUserActive in the
// Zustand store stays in sync with the Supabase session no matter
// which route the user is on or refreshes into. Every other call
// to useUserProfile() elsewhere in the app shares this same cached
// query (same queryKey) — this doesn't cause duplicate fetches.
export default function ProfileSyncWatcher() {
  useUserProfile();
  return null;
}